import { auth, db } from '../config/firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

export interface HomeworkFile {
  id: string;
  name: string;
  url: string;
  uploadedBy: string;
  uploadedAt: Date;
  size: number;
}

export class HomeworkQueryService {
  // Get all homework files for a session (Firestore only)
  static async getHomeworkFiles(sessionId: number): Promise<HomeworkFile[]> {
    // Check if user is authenticated
    const currentUser = auth.currentUser;
    if (!currentUser) {
      return [];
    }

    try {
      // Query Firestore for user's homework files in this session
      const q = query(
        collection(db, 'homework'),
        where('uploadedBy', '==', currentUser.uid),
        where('sessionId', '==', sessionId)
      );

      const querySnapshot = await getDocs(q);
      const files: HomeworkFile[] = [];

      querySnapshot.forEach((doc) => {
        const data = doc.data();
        files.push({
          id: data.fileName,
          name: data.originalName,
          url: data.url,
          uploadedBy: data.uploadedBy,
          uploadedAt: data.uploadedAt.toDate(),
          size: data.size,
        });
      });

      return files.sort((a, b) => b.uploadedAt.getTime() - a.uploadedAt.getTime());
    } catch (error) {
      console.error('Error getting homework files:', error);
      return [];
    }
  }
} 